import { render } from "./BaseCard.vue?vue&type=template&id=40cc1c28&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=40cc1c28&lang=scss&scoped=true"

import exportComponent from "E:\\myProjects\\myPortfolio\\my-portfolio-vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cc1c28"]])

export default __exports__